module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADRJREFUeNpcjAEKADAIAtP//9nVmGATQvBSSqqWxvMI4BK7xaZ4FSzwh24yv3J2gZw9AgwAGZEj/RsjMkMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/overlays/08.png
// module id = 675
// module chunks = 1